import { Star, Quote } from "lucide-react";

export function ReviewCard({ review, rotation = 0 }) {
  return (
    <article
      data-testid={`review-card-${review.id}`}
      className="parchment-card rounded-3xl p-7 relative"
      style={{ transform: `rotate(${rotation}deg)` }}
    >
      <Quote className="absolute -top-4 -left-2 w-9 h-9 text-[#3F2A56] bg-[#F4E8C8] rounded-full p-2 border-2 border-[#3F2A56]/20" />
      <div className="flex items-center gap-1.5 mb-3">
        {Array.from({ length: 5 }).map((_, i) => (
          <Star
            key={i}
            className={`w-4 h-4 ${
              i < review.rating
                ? "fill-[#D4AF37] text-[#D4AF37]"
                : "text-[#3F2A56]/20"
            }`}
          />
        ))}
      </div>
      <h4 className="font-display text-xl font-semibold text-[#3F2A56] leading-tight">
        {review.title}
      </h4>
      <p className="text-[#5C4A73] mt-3 leading-relaxed">{review.body}</p>
      <footer className="mt-5 pt-4 border-t border-dashed border-[#3F2A56]/20 flex items-center justify-between">
        <div>
          <div className="font-display font-semibold text-[#3F2A56]">
            {review.client_name}
          </div>
          {review.pet_name && (
            <div className="font-script text-[#b85b7e] text-lg leading-none">
              & {review.pet_name} 🐾
            </div>
          )}
        </div>
        <span className="text-xs text-[#5C4A73]">
          {new Date(review.created_at).toLocaleDateString("en-US", {
            month: "short",
            year: "numeric",
          })}
        </span>
      </footer>
    </article>
  );
}
